import * as React from 'react';
import hideDialogAndInvokeCallbackOnError from '../utils/hideDialogAndInvokeCallbackOnError';
import SsoOmexConsentDialog from './SsoOmexConsentDialog';
import SsoSignInDialog from './SsoMfaSignInDialog';
import strings from 'owa-strings/owa-extensibility-strings';
import { Dialog } from 'office-ui-fabric-react/lib/Dialog';
import { DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { getClientVersion, getUserCulture } from 'owa-session-store';
import { getSsoDialog, SsoDialogType } from 'owa-addins-store';
import { observer } from 'mobx-react';
import { SsoErrorCode } from '../schema/SsoErrorCode';

let styles = require('./SsoDialogStyles.scss');

interface SsoDialog {
    component: JSX.Element;
    title: string;
    type: DialogType;
}

@observer
export default class SsoDialogWrapper extends React.Component<{}, {}> {
    render(): JSX.Element {
        const dialog = getSsoDialog();
        const dialogVisibility = dialog.isVisible ? '' : styles.hiddenContainer;
        const ssoDialog: SsoDialog = this.createSsoDialog(dialog.type);
        if (!ssoDialog) {
            return <div />;
        }
        return (
            <div>
                <Dialog
                    isOpen={dialog.isOpen}
                    type={ssoDialog.type}
                    onDismiss={this.closeDialog.bind(this)}
                    title={ssoDialog.title}
                    modalProps={{
                        isBlocking: true,
                        containerClassName: 'ms-dialogMainOverride',
                    }}
                    className={dialogVisibility}>
                    {ssoDialog.component}
                </Dialog>
            </div>
        );
    }

    private closeDialog() {
        hideDialogAndInvokeCallbackOnError(SsoErrorCode.UserAborted);
    }

    private createSsoDialog(type: SsoDialogType): SsoDialog {
        switch (type) {
            case SsoDialogType.OmexConsent:
                const userCulture = getUserCulture();
                const owaVersion = getClientVersion();
                return {
                    component: (
                        <SsoOmexConsentDialog userCulture={userCulture} owaVersion={owaVersion} />
                    ),
                    title: strings.ssoConsentPermissionTitleText,
                    type: DialogType.close,
                };

            case SsoDialogType.MFASignIn:
                return {
                    component: <SsoSignInDialog />,
                    title: strings.ssoSignInButtonText,
                    type: DialogType.normal,
                };
            default:
                return null;
        }
    }
}
